<div class="container">
  <div class="fretboard">
    <app-string [open]="'E'" [notes]="notes"></app-string>
    <app-string [open]="'B'" [notes]="notes"></app-string>
    <app-string [open]="'G'" [notes]="notes"></app-string>
    <app-string [open]="'D'" [notes]="notes"></app-string>
    <app-string [open]="'A'" [notes]="notes"></app-string>
    <app-string [open]="'E'" [notes]="notes"></app-string>
  </div>
</div>
